/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    PaginationInfoToJSONTyped,
} from './PaginationInfo';
import type { Guild } from './Guild';
import {
    GuildFromJSON,
    GuildFromJSONTyped,
    GuildToJSON,
    GuildToJSONTyped,
} from './Guild';

/**
 * 
 * @export
 * @interface GetGuildsResponse
 */
export interface GetGuildsResponse {
    /**
     * 
     * @type {PaginationInfo}
     * @memberof GetGuildsResponse
     */
    paginationInfo: PaginationInfo;
    /**
     * 
     * @type {Array<Guild>}
     * @memberof GetGuildsResponse
     */
    guilds: Array<Guild>;
}

/**
 * Check if a given object implements the GetGuildsResponse interface.
 */
export function instanceOfGetGuildsResponse(value: object): value is GetGuildsResponse {
    if (!('paginationInfo' in value) || value['paginationInfo'] === undefined) return false;
    if (!('guilds' in value) || value['guilds'] === undefined) return false;
    return true;
}

export function GetGuildsResponseFromJSON(json: any): GetGuildsResponse {
    return GetGuildsResponseFromJSONTyped(json, false);
}

export function GetGuildsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetGuildsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'paginationInfo': PaginationInfoFromJSON(json['paginationInfo']),
        'guilds': ((json['guilds'] as Array<any>).map(GuildFromJSON)),
    };
}

export function GetGuildsResponseToJSON(json: any): GetGuildsResponse {
    return GetGuildsResponseToJSONTyped(json, false);
}

export function GetGuildsResponseToJSONTyped(value?: GetGuildsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paginationInfo': PaginationInfoToJSON(value['paginationInfo']),
        'guilds': ((value['guilds'] as Array<any>).map(GuildToJSON)),
    };
}

